var Icon, m;

m = require('mithril');

Icon = function(content, classname) {
  if (classname == null) {
    classname = 'Icon';
  }
  return m("span." + classname + "[aria-hidden=true][data-icon=" + content + "]");
};

Icon.home = Icon.bind(Icon, "\ue900");

Icon.image = Icon.bind(Icon, "\ue901");

Icon.gallery = Icon.bind(Icon, "\ue902");

Icon.right = Icon.bind(Icon, "\ue903");

Icon.left = Icon.bind(Icon, "\ue904");

Icon.grid = Icon("\ue905");

Icon.location = Icon.bind(Icon, "\ue906");

Icon.compass = Icon.bind(Icon, "\ue907");

Icon.calendar = Icon.bind(Icon, "\ue908");

Icon.profile = Icon.bind(Icon, "\ue909");

Icon.warning = Icon.bind(Icon, "\ue90a");

module.exports = Icon;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9JY29uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3VpL2NvbXBvbmVudHMvSWNvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFNBQVI7O0FBRUosSUFBQSxHQUFPLFNBQUMsT0FBRCxFQUFVLFNBQVY7O0lBQVUsWUFBWTs7U0FDNUIsQ0FBQSxDQUFFLE9BQUEsR0FBUSxTQUFSLEdBQWtCLCtCQUFsQixHQUFpRCxPQUFqRCxHQUF5RCxHQUEzRDtBQURNOztBQUlQLElBQUksQ0FBQyxJQUFMLEdBQVksSUFBSSxDQUFDLElBQUwsQ0FBVSxJQUFWLEVBQWdCLFFBQWhCOztBQUNaLElBQUksQ0FBQyxLQUFMLEdBQWMsSUFBSSxDQUFDLElBQUwsQ0FBVSxJQUFWLEVBQWdCLFFBQWhCOztBQUNkLElBQUksQ0FBQyxPQUFMLEdBQWdCLElBQUksQ0FBQyxJQUFMLENBQVUsSUFBVixFQUFnQixRQUFoQjs7QUFDaEIsSUFBSSxDQUFDLEtBQUwsR0FBYyxJQUFJLENBQUMsSUFBTCxDQUFVLElBQVYsRUFBZ0IsUUFBaEI7O0FBQ2QsSUFBSSxDQUFDLElBQUwsR0FBYSxJQUFJLENBQUMsSUFBTCxDQUFVLElBQVYsRUFBZ0IsUUFBaEI7O0FBQ2IsSUFBSSxDQUFDLElBQUwsR0FBWSxJQUFBLENBQUssUUFBTDs7QUFDWixJQUFJLENBQUMsUUFBTCxHQUFpQixJQUFJLENBQUMsSUFBTCxDQUFVLElBQVYsRUFBZ0IsUUFBaEI7O0FBQ2pCLElBQUksQ0FBQyxPQUFMLEdBQWdCLElBQUksQ0FBQyxJQUFMLENBQVUsSUFBVixFQUFnQixRQUFoQjs7QUFDaEIsSUFBSSxDQUFDLFFBQUwsR0FBaUIsSUFBSSxDQUFDLElBQUwsQ0FBVSxJQUFWLEVBQWdCLFFBQWhCOztBQUNqQixJQUFJLENBQUMsT0FBTCxHQUFnQixJQUFJLENBQUMsSUFBTCxDQUFVLElBQVYsRUFBZ0IsUUFBaEI7O0FBQ2hCLElBQUksQ0FBQyxPQUFMLEdBQWdCLElBQUksQ0FBQyxJQUFMLENBQVUsSUFBVixFQUFnQixRQUFoQjs7QUFFaEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
